/**
 *
 * User
 *
 */
import NoPermissionsCard from 'app/components/NoPermissionsCard/NoPermissionsCard';
import React from 'react';
import { useSelector } from 'react-redux';
import {
  generatePath,
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
} from 'react-router-dom';
import { RouteConstants } from '../../routes';
import { selectPermissions } from '../Authorization/slice/selectors';
import UserDetails from './pages/UserDetails/UserDetails';
import UserList from './pages/UserList/UserList';

interface IProps extends RouteComponentProps {}

export function User(props: IProps) {
  const { usersAdministration } = useSelector(selectPermissions);
  if (usersAdministration === 0) {
    return <NoPermissionsCard />;
  }

  return (
    <Switch>
      <Route path={RouteConstants.user.list} component={UserList} />
      <Route path={RouteConstants.user.details} component={UserDetails} />
      <Route
        exact
        path={RouteConstants.user.index}
        render={props => (
          <Redirect
            to={generatePath(RouteConstants.user.list, {
              envId: Number(props.match.params.envId),
            })}
          />
        )}
      />
    </Switch>
  );
}
